module.exports = __webpack_public_path__ + "img/payment_pc_07.9b307e7a.png";